import api from "../../utils/api";

/**
 * Fetch all form packages
 * @returns {Promise<Array>} Array of form packages
 */
export const getFormPackages = async () => {
  try {
    const response = await api.get("/form-packages");
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error("Failed to fetch packages");
  } catch (error) {
    console.error("Error fetching form packages:", error);
    throw error;
  }
};

/**
 * Fetch a single form package by ID
 * @param {string|number} packageId - The package ID
 * @returns {Promise<Object>} Package details
 */
export const getFormPackageById = async (packageId) => {
  try {
    const response = await api.get(`/form-packages/${packageId}`);
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error("Failed to fetch package details");
  } catch (error) {
    console.error("Error fetching package details:", error);
    throw error;
  }
};
